__turbopack_context__.v({
  "error-message": "_9Scltq_error-message",
  "field-wrapper": "_9Scltq_field-wrapper",
  "footer": "_9Scltq_footer",
  "forced-error": "_9Scltq_forced-error",
  "input": "_9Scltq_input",
  "input-centered": "_9Scltq_input-centered",
  "label": "_9Scltq_label",
  "label-centered": "_9Scltq_label-centered",
  "placeholder": "_9Scltq_placeholder",
  "wrapper": "_9Scltq_wrapper",
});
